import { render, staticRenderFns } from "./DefaultViewLayout.vue?vue&type=template&id=38a864d4&scoped=true&"
import script from "./DefaultViewLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultViewLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultViewLayout.vue?vue&type=style&index=0&id=38a864d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a864d4",
  null
  
)

export default component.exports